import styles from "./index.module.scss"
import eventBus from "@utils/eventBus";
import InviteUserModal from '@view/compoents/inviteUserModal/inviteUserModal'
import { useContext } from "react";
import { AppContext } from '@utils/AppContext';
import Utils from '@utils/utils';
import { HOME_PAGE_TYPE } from "@utils/CONST"
import { useNavigate } from "react-router";

function MembershipBtn (props) {
    return <>
        <div className={styles.MembershipBtn} onClick={props.onClick}>
            <i></i>
            <span>会员低至0.16元/图</span>
        </div>
    </>
}

function NewUserBtn (props) {
    const navigate = useNavigate();

    const handleClick = () => {
        eventBus.emit('login', {
            callback: logged => {
                if (logged) {
                    Utils.useroplog(HOME_PAGE_TYPE.CLOTHING, 'function', 'navigation', { from: 'home' })
                    Utils.clearAllTaskCache()
                    navigate("/home/homemain/clothes")
                }
                else console.log('取消了登录')
            }
        })
    }

    return <>
        <div className={styles.NewUserBtn} onClick={handleClick}>
            <i></i>
            <span>新人免费生图60张</span>
        </div>
    </>
}

function InviteBtn (props) {
    const { globalUser } = useContext(AppContext);

    return <>
        <div className={styles.InviteBtn} onClick={() => eventBus.emit('inviteUser')}>
            <i></i>
            <span>邀请有礼</span>
        </div>
        <InviteUserModal invitationCode={globalUser?.invitationCode} />
    </>
}

export {
    MembershipBtn,
    NewUserBtn,
    InviteBtn
}